export default __webpack_public_path__ + "static/media/1564.6691b17d.png";